export const messages = {
  en: {
    machinePrinterManage: {
      search: {
        title: 'Search Conditions',
        machineName: 'Machine Name',
        machineCode: 'Machine Code'
      },
      list: {
        title: 'Cloud Printer List'
      },
      table: {
        machineId: 'Machine ID',
        machineName: 'Machine Name',
        machineCode: 'Machine Code',
        implBeanName: 'Manufacturer'
      },
      form: {
        machineName: 'Machine Name',
        machineCode: 'Machine Code',
        implBean: 'Manufacturer',
        machineNamePlaceholder: 'Please enter machine name',
        machineCodePlaceholder: 'Please enter machine code',
        implBeanPlaceholder: 'Please select manufacturer'
      },
      validate: {
        machineIdRequired: 'Machine ID is required',
        machineNameRequired: 'Machine name is required',
        machineNameMaxLength: 'Machine name cannot exceed 200 characters',
        machineCodeRequired: 'Machine code is required',
        machineCodeMaxLength: 'Machine code cannot exceed 30 characters',
        implBeanRequired: 'Manufacturer is required',
        implBeanMaxLength: 'Manufacturer cannot exceed 30 characters'
      },
      message: {
        addSuccess: 'Add successfully',
        editSuccess: 'Edit successfully',
        deleteSuccess: 'Delete successfully',
        fetchError: 'Failed to fetch data'
      },
      add: {
        title: 'Add Printer'
      },
      edit: {
        title: 'Edit Printer'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this cloud printer?'
      }
    }
  },
  zh: {
    machinePrinterManage: {
      search: {
        title: '查询条件',
        machineName: '设备名称',
        machineCode: '设备编码'
      },
      list: {
        title: '云打印机列表'
      },
      table: {
        machineId: '设备编号',
        machineName: '设备名称',
        machineCode: '设备编码',
        implBeanName: '厂家'
      },
      form: {
        machineName: '设备名称',
        machineCode: '设备编码',
        implBean: '厂家',
        machineNamePlaceholder: '请输入设备名称',
        machineCodePlaceholder: '请输入设备编码',
        implBeanPlaceholder: '请选择厂家'
      },
      validate: {
        machineIdRequired: '设备编号不能为空',
        machineNameRequired: '设备名称不能为空',
        machineNameMaxLength: '设备名称不能超过200个字符',
        machineCodeRequired: '设备编码不能为空',
        machineCodeMaxLength: '设备编码不能超过30个字符',
        implBeanRequired: '厂家不能为空',
        implBeanMaxLength: '厂家不能超过30个字符'
      },
      message: {
        addSuccess: '添加成功',
        editSuccess: '修改成功',
        deleteSuccess: '删除成功',
        fetchError: '获取数据失败'
      },
      add: {
        title: '添加打印机'
      },
      edit: {
        title: '修改打印机'
      },
      delete: {
        title: '删除确认',
confirmText: '确定删除该云打印机吗？'
      }
    }
  },
  'zh-TW': {
    machinePrinterManage: {
      search: {
        title: '查詢條件',
        machineName: '設備名稱',
        machineCode: '設備編碼'
      },
      list: {
        title: '雲列印機列表'
      },
      table: {
        machineId: '設備編號',
        machineName: '設備名稱',
        machineCode: '設備編碼',
        implBeanName: '廠家'
      },
      form: {
        machineName: '設備名稱',
        machineCode: '設備編碼',
        implBean: '廠家',
        machineNamePlaceholder: '請輸入設備名稱',
        machineCodePlaceholder: '請輸入設備編碼',
        implBeanPlaceholder: '請選擇廠家'
      },
      validate: {
        machineIdRequired: '設備編號不能為空',
        machineNameRequired: '設備名稱不能為空',
        machineNameMaxLength: '設備名稱不能超過200個字符',
        machineCodeRequired: '設備編碼不能為空',
        machineCodeMaxLength: '設備編碼不能超過30個字符',
        implBeanRequired: '廠家不能為空',
        implBeanMaxLength: '廠家不能超過30個字符'
      },
      message: {
        addSuccess: '添加成功',
        editSuccess: '修改成功',
        deleteSuccess: '刪除成功',
        fetchError: '獲取數據失敗'
      },
      add: {
        title: '添加列印機'
      },
      edit: {
        title: '修改列印機'
      },
      delete: {
        title: '刪除確認',
        confirmText: '確定刪除該雲列印機嗎？'
      }
    }
  }
}